import { defineComponent, h } from 'vue'
import { icons } from './icons'

/**
 * 与 @iconify/vue 的 <Icon icon="lucide:xxx"> 用法一致的本地图标组件。
 *
 * - 根节点就是 <svg>（模板与用例里的 `> svg` 选择器照常命中）；
 * - 同步渲染，不发任何网络请求（iconify 在线拉取在国内与内置浏览器里不稳定）；
 * - 子节点用 vnode 逐个生成，不走 svg.innerHTML —— 老 WebView 上 SVG 元素的 innerHTML 不可靠；
 * - 默认 aria-hidden，与 iconify 的默认行为一致：图标都是装饰，语义由旁边的文字承担。
 */
export const Icon = defineComponent({
  name: 'LocalIcon',
  props: {
    icon: { type: String, required: true },
  },
  setup(props) {
    return () => {
      const name = props.icon.replace(/^lucide:/, '')
      const nodes = icons[name] || []
      return h(
        'svg',
        {
          xmlns: 'http://www.w3.org/2000/svg',
          width: '1em',
          height: '1em',
          viewBox: '0 0 24 24',
          fill: 'none',
          stroke: 'currentColor',
          'stroke-width': '2',
          'stroke-linecap': 'round',
          'stroke-linejoin': 'round',
          'aria-hidden': 'true',
          focusable: 'false',
          class: 'official-icon',
        },
        nodes.map(([tag, attrs]) => h(tag, attrs)),
      )
    }
  },
})
